import React from 'react';
import styles from './VideoLoader.module.scss';
import { CircularProgress } from '@material-ui/core';

const VideoLoader = () => {
	return (
		<div className={styles.loading_layout_videocall}>
			<div className={styles.inner_loading_layout}>
				<CircularProgress className={styles.circular_load} />
				<div className={styles.authenticate_text}>
					<p>Authenticating...</p>
				</div>
			</div>
		</div>
	);
};

export default VideoLoader;
